import { SOURCES } from './sources.js';

export const TIMELINE = [
  // ── Pre-year deadlines (already past — still informational) ─────────────────
  {
    id: 'course-selection-deadline',
    title: 'Course Selection Deadline',
    description:
      'The schedule-change window for 2026-27 closed March 12, 2026 at 4:00 PM. If you missed it, contact your counselor about options.',
    date: '2026-03-12',
    time: '4:00 PM',
    category: 'deadline',
    priority: 'high',
    actionRequired: false,
    actionText: null,
    actionUrl: null,
    source: SOURCES.crmsCounseling,
  },
  {
    id: 'transport-registration-opens',
    title: 'Transportation Registration Opens',
    description:
      'Annual bus registration for 2026-27 opened April 1, 2026. All eligible riders must register each year — it is not automatic from year to year.',
    date: '2026-04-01',
    time: null,
    category: 'registration',
    priority: 'high',
    actionRequired: true,
    actionText: 'Register via LISD Transportation info page',
    actionUrl: 'https://www.leanderisd.org/transportation_businformation/',
    source: SOURCES.busInfo,
  },
  {
    id: 'mlisd-reservations-open',
    title: 'mLISD Laptop Reservations Open',
    description:
      'Reserve the school-issued Chromebook (Lenovo 500e Convertible) for 2026-27 via MySchoolBucks. Security deposit: $40/year; $0 for free/reduced-meal families. Hardship scholarships available — contact your counselor.',
    date: '2026-04-01',
    time: null,
    category: 'registration',
    priority: 'medium',
    actionRequired: true,
    actionText: 'Reserve at MySchoolBucks',
    actionUrl: 'https://www.myschoolbucks.com',
    source: SOURCES.mLisd,
  },

  // ── Summer ──────────────────────────────────────────────────────────────────
  {
    id: 'orientation-2026',
    title: '6th Grade Orientation',
    description:
      'Schedule pickup, locker assignments, and campus tour for incoming 6th graders. Typically held in early August before the first day. Specific date not yet posted for 2026-27.',
    date: null,
    dateLabel: 'TBA — early August 2026',
    category: 'milestone',
    priority: 'high',
    actionRequired: false,
    actionText: 'Watch for announcement from CRMS on ParentSquare',
    actionUrl: null,
    source: SOURCES.crmsRegistrar,
  },
  {
    id: 'first-day-2026',
    title: 'First Day of School',
    description:
      '6th grade officially begins at Canyon Ridge. Doors open 8:35 AM; first bell 9:05 AM.',
    date: '2026-08-12',
    time: '9:05 AM',
    category: 'milestone',
    priority: 'high',
    actionRequired: false,
    actionText: null,
    actionUrl: null,
    source: SOURCES.lisdCalendar2627,
  },

  // ── Fall Semester ────────────────────────────────────────────────────────────
  {
    id: 'picture-day-2026',
    title: 'Picture Day',
    description:
      'Official school portrait day. Date not yet published for 2026-27. Watch for ParentSquare messages from CRMS in August.',
    date: null,
    dateLabel: 'TBA — watch ParentSquare',
    category: 'school-event',
    priority: 'low',
    actionRequired: false,
    actionText: null,
    actionUrl: null,
    source: SOURCES.crmsHome,
  },
  {
    id: 'report-card-1',
    title: '1st Six-Weeks Report Card',
    description:
      'First grading period results available in Home Access Center (HAC). LISD uses six-week grading periods at the secondary level.',
    date: null,
    dateLabel: 'TBA — approx. late September 2026',
    category: 'academic',
    priority: 'medium',
    actionRequired: false,
    actionText: 'View grades at Home Access Center',
    actionUrl: 'https://www.leanderisd.org/homeaccesscenter/',
    source: SOURCES.hac,
  },
  {
    id: 'fall-break-2026',
    title: 'Fall Break',
    description:
      'Full week off in October. The 2026-27 calendar includes refined mid-semester breaks with a professional-learning day on Friday and Monday/Tuesday off.',
    date: '2026-10-12',
    dateLabel: 'Week of Oct 12, 2026 (approx.)',
    category: 'milestone',
    priority: 'low',
    actionRequired: false,
    actionText: null,
    actionUrl: null,
    source: SOURCES.lisdCalendar2627,
    note: 'Exact dates subject to confirmation on the 2026-27 calendar PDF.',
  },

  // ── Winter ───────────────────────────────────────────────────────────────────
  {
    id: 'winter-break-2026',
    title: 'Winter Break',
    description:
      'Two-week winter break. Exact dates TBA on the 2026-27 academic calendar.',
    date: '2026-12-21',
    dateLabel: 'Approx. Dec 21, 2026 – Jan 4, 2027',
    category: 'milestone',
    priority: 'low',
    actionRequired: false,
    actionText: null,
    actionUrl: null,
    source: SOURCES.lisdCalendar2627,
    note: 'Confirm exact dates on the 2026-27 academic calendar PDF.',
  },

  // ── Spring Semester ──────────────────────────────────────────────────────────
  {
    id: 'february-break-2027',
    title: 'February Break',
    description:
      'Mid-semester break — Monday/Tuesday off plus a professional-learning day on Friday. Based on the 2026-27 calendar refinements.',
    date: null,
    dateLabel: 'TBA — February 2027',
    category: 'milestone',
    priority: 'low',
    actionRequired: false,
    actionText: null,
    actionUrl: null,
    source: SOURCES.lisdCalendar2627,
  },
  {
    id: 'spring-break-2027',
    title: 'Spring Break',
    description:
      'Full week off for Spring Break. Exact dates TBA on the 2026-27 academic calendar.',
    date: '2027-03-15',
    dateLabel: 'Approx. Mar 15–19, 2027',
    category: 'milestone',
    priority: 'low',
    actionRequired: false,
    actionText: null,
    actionUrl: null,
    source: SOURCES.lisdCalendar2627,
    note: 'Confirm exact dates on the 2026-27 academic calendar PDF.',
  },
  {
    id: 'gt-referral-window',
    title: 'GT/QUEST Spring Referral Deadline',
    description:
      'Secondary GT screening happens only in spring. Referral forms open Oct. 1 each year and are accepted year-round, but the spring deadline gates placement for the following school year. Spring 2026 deadline was March 6, 2026; watch for the 2026-27 announcement.',
    date: null,
    dateLabel: 'TBA — approx. March 2027 (for 2027-28 placement)',
    category: 'deadline',
    priority: 'medium',
    actionRequired: true,
    actionText: 'Referral info at LISD QUEST page',
    actionUrl: 'https://www.leanderisd.org/quest_screeningidentificationprocess/',
    source: SOURCES.questGt,
  },
  {
    id: 'sex-ed-opt-in-deadline',
    title: 'Human Sexuality Opt-In Deadline (7th & 8th Grade)',
    description:
      'Parents of 7th and 8th graders must submit the opt-in form before this deadline. In 2025 the deadline was May 5. Watch for the 2026-27 announcement in spring.',
    date: null,
    dateLabel: 'TBA — watch for announcement in spring 2027',
    category: 'deadline',
    priority: 'high',
    actionRequired: true,
    actionText: 'Opt-in form at CRMS Human Sexuality page',
    actionUrl: 'https://crms.leanderisd.org/parent_resources/human-sexuality-7th-8th',
    source: SOURCES.humanSexuality,
  },
  {
    id: 'staar-testing',
    title: 'STAAR Testing',
    description:
      'State of Texas Assessments of Academic Readiness. Specific windows not yet posted for 2026-27. Typically held in late April and May. Covers Math, Reading/Writing, and other subjects by grade.',
    date: null,
    dateLabel: 'TBA — late April / May 2027',
    category: 'academic',
    priority: 'high',
    actionRequired: false,
    actionText: null,
    actionUrl: null,
    source: SOURCES.studentHandbook,
  },
  {
    id: 'sex-ed-curriculum-window',
    title: 'Human Sexuality Curriculum Lessons (7th & 8th)',
    description:
      'Four lessons delivered to opted-in 7th and 8th graders via Google Classroom. In 2025 this was May 12–14. 6th graders receive separate puberty lessons via PE/Pre-Athletics in spring.',
    date: null,
    dateLabel: 'TBA — mid-May 2027 (similar to 2025)',
    category: 'school-event',
    priority: 'medium',
    actionRequired: false,
    actionText: null,
    actionUrl: null,
    source: SOURCES.humanSexuality,
  },
  {
    id: 'course-selection-2728',
    title: 'Course Selection for 2027-28',
    description:
      'Schedule selection for next year — 7th grade courses. Watch for the counselor-led process in February. In 2025-26 the schedule-change deadline was March 12.',
    date: null,
    dateLabel: 'TBA — February/March 2027',
    category: 'deadline',
    priority: 'medium',
    actionRequired: true,
    actionText: 'Contact counselor for info',
    actionUrl: null,
    source: SOURCES.crmsCounseling,
  },
  {
    id: 'last-day-2027',
    title: 'Last Day of School',
    description:
      'Final day of the 2026-27 school year. Early-release dismissal at 1:05 PM.',
    date: '2027-05-27',
    time: '1:05 PM',
    category: 'milestone',
    priority: 'high',
    actionRequired: false,
    actionText: null,
    actionUrl: null,
    source: SOURCES.lisdCalendar2627,
  },
];

export default TIMELINE;
